import { Component, OnInit, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, ToastController } from '@ionic/angular';
import { UserProfile } from '../../models/user-profile.model';
import { UtilService } from '../../service/util.service';
import { environment } from '../../../environments/environment';
import { HomeService } from './home.service';
import { AES } from 'crypto-js';
import { NavigationExtras } from '@angular/router';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  dataStock: any[] = [];
  dataPoAuto: any[] = [];
  listMonth:any[]=[];
  counterId :any=0;
  warehouseId : any=0;
  listCounter : any[] = [];
  selectedCounter:any[] = [];
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private utilService: UtilService,
    private homeService: HomeService
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        window.dispatchEvent(new CustomEvent('user:getmenu'));
        this.selectedCounter=[];
        this.getDataCounter();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  selectCounter(event){
    this.counterId = event.value.id;
    this.dataPoAuto = [];
    this.getDataStock();
  }
  getMonthsInRange(startDateStr: string, endDateStr: string): number[] {
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);
      const result: number[] = [];

      // Normalisasi ke awal bulan
      start.setDate(1);
      end.setDate(1);

      while (start <= end) {
        const month = start.getMonth() + 1; // getMonth() 0–11 → +1 jadi 1–12
        result.push(month);

        // Tambah 1 bulan
        start.setMonth(start.getMonth() + 1);
      }

      return result;
  }

  getDataPoAuto() {
    this.dataPoAuto = [];
    const bulanIndonesia = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni','Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    let newDate = new Date();
    let threeMonthsAgo = new Date(newDate);
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    let tahun = threeMonthsAgo.getFullYear();
    let start_date = tahun+'-'+(threeMonthsAgo.getMonth() + 1).toString().padStart(2, '0')+'-01';
    let lastDayOfLastMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
    let year = lastDayOfLastMonth.getFullYear();
    let month = (lastDayOfLastMonth.getMonth() + 1).toString().padStart(2, '0'); // tambahkan 0 di depan jika < 10
    let day = lastDayOfLastMonth.getDate().toString().padStart(2, '0');
    let formattedDate = `${year}-${month}-${day}`;

    const bulan = this.getMonthsInRange(start_date, formattedDate);
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let options = {
        "token": this.token,
        "year": convertDate.years,
        "month": convertDate.months,
        "today": todayDate,
        "start_date": start_date,
        "end_date": formattedDate,
        "cashier_id": this.userProfile.cashier_id ? this.userProfile.cashier_id : 0,
        "counter_id": this.counterId
      };

      this.homeService.getDashboardPoAuto(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let salesData: any[] = response.results.data_sales;
        let stockData: any[] = response.results.data_stock;
        let jumlah_hari : any = response.results.jumlah_hari;
        for(let y = 0; y < bulan.length; y++) {
          let bulannam = bulanIndonesia[bulan[y]-1];
          this.listMonth.push(bulannam);
        }
        this.counterId =  response.results.counter_id;
        if(response.results.warehouse){
          this.warehouseId =response.results.warehouse.id;
        }
        if(stockData.length > 0) {
          for(let x = 0; x < stockData.length; x++) {
            let pcode = stockData[x].product_id;
            let getStock = stockData.find(z => z.product_id === pcode);
            let stock =0;
            if(getStock){
              stock = getStock[`end_${month}`];
            }
            let productName = stockData[x].product_name;
            let getSales = [];
            let totalSales = 0;
            let asq =0;
            for(let y = 0; y < bulan.length; y++) {
              let sales1 = salesData.find(z => z.product_id === pcode && z.month==bulan[y]);
              let total_qty =0;
              if(sales1){
                total_qty = parseInt(sales1.total_qty);
              }
              getSales.push(total_qty);
              totalSales+=total_qty;
              asq = totalSales/jumlah_hari;
            }
            let data = {
              pcode: pcode,
              name: productName,
              getSales: getSales,
              totalSales: totalSales,
              jumlah_hari:jumlah_hari,
              stock:stock,
              asq : asq,
              turnover_stock : stock/asq,
              qty_po:stock/asq<=15 ?this.hitungNilai(asq) :''
            }
            this.dataPoAuto.push(data);
          }
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  hitungNilai(n22: number): number | string {
    const hasil = Math.ceil((18 * n22) / 3) * 3;
    if(hasil>0){
      return hasil;
    }
    else{
      return '';
    }
  }
  createPO(){
    let id='secret#'+this.counterId.toString()+'#'+this.warehouseId.toString();
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID
      }
    };
    this.navCtrl.navigateForward(['/product-request/po-auto'], navigationExtras);
  }
  getDataCounter() {
    let cashier_id = this.userProfile.cashier_id ? this.userProfile.cashier_id : 0;
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token
      };
      this.homeService.getCounterData(cashier_id,options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let cashierData =  response.results.data;
        const allowedIds = this.userProfile.counter_id_list; // array of allowed IDs
        this.listCounter= response.results.counter_data.filter(counter =>
          allowedIds.includes(counter.id)
        );
        if(cashierData){
          this.counterId = cashierData.counter_id;
          let selectedCounter: any = this.listCounter.find(x => x.id ==  this.counterId);
          if(selectedCounter){
            let idx =this.listCounter.indexOf(selectedCounter);
            this.selectedCounter=(this.listCounter[idx]);
          }
          this.getDataStock();
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  getDataStock() {
    this.dataStock = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let newDate = new Date();
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let dateOfMonth = this.utilService.getFirstAndLastDateofMonth();
      let options = {
        "token": this.token,
        "year": convertDate.years,
        "month": convertDate.months,
        "today": todayDate,
        "start_date": dateOfMonth.startDate,
        "end_date": dateOfMonth.endDate,
        "cashier_id": this.userProfile.cashier_id ? this.userProfile.cashier_id : 0,
        "counter_id": this.counterId
      };
      this.homeService.getDashboardStockData(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let stockData: any[] = response.results.stock_data;
        if(stockData.length > 0) {
          let todayTransactionData: any[] = response.results.today_transaction_data;
          let monthTransactionData: any[] = response.results.month_transaction_data;
          let productData: any[] = response.results.productData;
          for(let x = 0; x < stockData.length; x++) {
            let stockQty = this.getStock(convertDate.months, stockData[x]);
            let pcode: any = stockData[x].pcode;
            let checkTodayTrans: any = todayTransactionData.find(x => x.product_id === pcode);
            let checkMonthTrans: any = monthTransactionData.find(x => x.product_id === pcode);
            let checkProduct :any = productData.find(x=>x.pcode==pcode);
            let data = {
              pcode: stockData[x].pcode,
              name: stockData[x].product_name,
              early: stockQty.early,
              in: stockQty.in,
              todayTransQty: checkTodayTrans ? parseInt(checkTodayTrans.qty) : 0,
              monthTransQty: checkMonthTrans ? parseInt(checkMonthTrans.qty) : 0,
              end: stockQty.end,
              min_stock :checkProduct ? checkProduct.min_stock : 0,
              max_stock :checkProduct ? checkProduct.max_stock : 0,
            }
            this.dataStock.push(data);
          }
          this.dataStock.sort((a, b) => b.todayTransQty - a.todayTransQty);
          this.getDataPoAuto();
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  getStock(month: any, data: any) {
    let earlyStock = data[`early_${month}`];
    let inStock = data[`in_${month}`];
    let endStock = data[`end_${month}`];
    return {
      early   : earlyStock,
      in      : inStock,
      end     : endStock
    };
  }
}